import { RootState } from '../store/configureStore';

export const getCustomer = (state: RootState) => state?.customer?.customer;

export const isFetchingCustomer = (state: RootState) =>
  state?.customer?.isFetchingCustomer;

export const didFetchingCustomerFailed = (state: RootState) =>
  state?.customer?.fetchingCustomerFailed;
